export default __webpack_public_path__ + "static/media/mandaluyong.d64d1797.jpg";